import { createContext } from 'react';

// Glossary term interface
export interface GlossaryTerm {
  id: string;
  term: string;
  description: string | null;
  letter: string;
}

// Glossary context interface
export interface GlossaryContextType {
  terms: GlossaryTerm[];
  loading: boolean;
  termIndex: Map<string, GlossaryTerm>;
  openTermByName: (name: string) => void;
  openTermById: (id: string) => void;
  closeTerm: () => void;
  activeTerm: GlossaryTerm | null;
}

export const GlossaryContext = createContext<GlossaryContextType>({
  terms: [] as GlossaryTerm[],
  loading: false,
  termIndex: new Map(),
  openTermByName: () => {},
  openTermById: () => {},
  closeTerm: () => {},
  activeTerm: null,
});
